<template>
  <section v-if="false">
    <b-container>
      <b-row align-h="center">
          <b-col
            v-for="(date, i) in dates"
            :key="i"
            cols="12"
            md="6"
            lg="auto"
            :class="{ 'col-md-12': i === 0 }"
            class="col"
          >
            <router-link :to="date.route">
              <img :src="require(`../../assets/icons/${date.icon}`)">
              {{ date.title }}
            </router-link>
          </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
import { getBaseMetaCurrentYear } from '@/environments'

export default {
  data () {
    return {
      dates: [
        {
          icon: 'message_icon.png',
          title: `About Adman ${getBaseMetaCurrentYear}`,
          route: {
            name: 'about'
          }
        },
        // {
        //   icon: 'trophy_icon.png',
        //   title: 'Awards',
        //   route: {
        //     name: 'awards'
        //   }
        // },
        {
          icon: 'light_icon.png',
          title: `Creativity Day ${getBaseMetaCurrentYear}`,
          route: {
            name: 'creativity'
          }
        },
        {
          icon: 'entry-kit.svg',
          title: `${getBaseMetaCurrentYear} Entry Kit`,
          route: {
            name: 'awards'
          }
        },
        {
          icon: 'chat.png',
          title: 'Archives 2004 to 2018',
          route: {
            name: 'archive'
          }
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/styles/variables.scss';

section {
  background-color: $light;

  .container {
    .row {
      .col {
        border-bottom: 1px solid #ADADAD;

        a {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 18px 0;
          font-size: 1.25rem;
          line-height: 0.8;

          img {
            margin-right: 6px;
            height: 32px;
          }
        }
      }
    }
  }
}

@media only screen and (min-width: $break-m) {
  section {
    .container {
      .row {
        .col:nth-child(odd) {
          border-left: 1px solid #ADADAD;
        }

        .col:first-child {
          border-left: none;
        }

        .col:nth-child(4), .col:nth-child(5) {
          border-bottom: none;
        }
      }
    }
  }
}

@media only screen and (min-width: $break-l) {
  section {
    .container {
      .row {
        .col:first-child {
          border-left: none;
        }

        .col {
          padding: 0 28px;
          border-left: 1px solid #ADADAD;
          border-bottom: none;
        }
      }
    }
  }
}
</style>
